import SkillEdit from "../Edits/SkillEdit";
import CmModal from "../Controls/CmModal";

export default function SkillEditModal({
  skillId = 0,
  initialName = "",
  onClose,
}) {
  const id = Number.parseInt(skillId, 10) || 0;
  const title = "Skill";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="wide"
      testId="skill-edit-modal"
    >
      <SkillEdit skillId={id} initialName={initialName} onClose={onClose} />
    </CmModal>
  );
}
